import "../../MainBox/MainBox.css";

export default function DisabledAccordDK() {
   

    return (
        <div className="accordion">
            <div className="accordion-item">
                <div className="accordion-header">
                    Notes
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>
            <div className="accordion-item">
                <div className="accordion-header">
                    Forecast & Reprint
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>

            <div className="accordion-item">
                <div className="accordion-header">
                    Demand DK
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>

            <div className="accordion-item">
                <div className="accordion-header">
                    Production DK
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>

            <div className="accordion-item">
                <div className="accordion-header">
                    Series Data
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>
            <div className="accordion-item">
                <div className="accordion-header">
                    Stock Overview
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>
            <div className="accordion-item">
                <div className="accordion-header">
                    Marketing & Publicity
                </div>
                <div className="accordion-content accordian-border">
                </div>
            </div>
        </div>
    );
}